import React from 'react';
import { FileText, History } from 'lucide-react';

interface LineRequesterProps {
  recentLines: string[];
  onRequestLine: () => Promise<void>;
}

const LineRequester: React.FC<LineRequesterProps> = ({ recentLines, onRequestLine }) => {
  return (
    <div className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <div className="flex items-center mb-4">
          <FileText className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
          <h3 className="ml-3 text-lg font-medium text-gray-900 dark:text-white">Get Line</h3>
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
          Request a line from the database
        </p>
        <button
          onClick={onRequestLine}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600"
        >
          Request Line
        </button>

        {/* Recent Lines */}
        {recentLines.length > 0 && (
          <div className="mt-4">
            <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-2">
              <History className="h-4 w-4 mr-1" />
              Recent Lines:
            </div>
            <div className="space-y-2">
              {recentLines.map((line, index) => (
                <div
                  key={index}
                  className="p-2 bg-gray-50 dark:bg-gray-700 rounded"
                >
                  <code className="text-sm font-mono text-gray-600 dark:text-gray-300 break-all">
                    {line}
                  </code>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LineRequester;